import angular from 'angular';

import FormSubmitDirective, { selector } from './form-submit.directive';

export default angular
    .module('application.directive.form-submit', [])
    .directive(selector, FormSubmitDirective);



// WEBPACK FOOTER //
// ./src/application/directive/form-submit/index.js